import React from 'react';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import useLanguageRegionCode from 'hooks/useLanguageRegionCode';
import LanguageRegionCode from '@alltrails/shared/types/LanguageRegionCode';
import getStore from '../store';

type Props = {
  children?: React.ReactNode;
};

function CustomProvider({ children }: Props) {
  const languageRegionCode = useLanguageRegionCode();
  const messages = global.__TRANSLATION_JSON__;

  return (
    <Provider store={getStore()}>
      <IntlProvider defaultLocale={LanguageRegionCode.English} locale={languageRegionCode} messages={messages}>
        {children}
      </IntlProvider>
    </Provider>
  );
}

export default CustomProvider;
